import type { SWRConfiguration } from 'swr'

import { useFacilitiesMeta } from '@/modules/Facilities'

export const useSearchAreaOptions = (
  {
    withCount = false,
  }: {
    withCount?: boolean
  } = {},
  config?: SWRConfiguration,
) => {
  const { data, ...rest } = useFacilitiesMeta(config)

  return {
    data:
      data?.prefectures.map((prefecture) => ({
        label: prefecture.name,
        value: prefecture.id,
        ...(withCount ? { count: prefecture.count } : {}),
        // Add children only if area exists
        ...(prefecture.areas.length > 0
          ? {
              children: prefecture.areas
                .sort((a, b) => a.order - b.order)
                .map((area) => ({
                  label: area.name,
                  value: area.id,
                  ...(withCount ? { count: area.count } : {}),
                })),
            }
          : {}),
      })) ?? [],
    ...rest,
  }
}
